import { useEffect, useState } from 'react';

import { getSourceEventParams, useAmplitude } from '@crehana/analytics';
import { useTranslation } from '@crehana/i18n';
import { CustomNextImage as Image } from '@crehana/next';
// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import { ProgressBar } from '@crehana/ui';
// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import { css } from 'styled-components';

import { AMPLITUDE_TRACKS } from '@/views/B2BLanding/events';

import { FormSteps } from '../../constants';
import useFormStepsContext from '../../hooks/useFormStepsContext';
import Count from './components/Count';
import StepCompleted from './components/StepCompleted';

const STEP_LOADING = [
  { id: 'step1', i18nKey: 'LOADER_FINAL_STEP_1' },
  { id: 'step2', i18nKey: 'LOADER_FINAL_STEP_2' },
  { id: 'step3', i18nKey: 'LOADER_FINAL_STEP_3' },
  { id: 'step4', i18nKey: 'LOADER_FINAL_STEP_4' },
];

const LoaderFinalStep = () => {
  const [stepLoading, setStepLoading] = useState(0);
  const { logEvent } = useAmplitude();
  const [isVisibleModal, setisVisibleModal] = useState<boolean>(false);
  const { nameUser } = useFormStepsContext();
  const { t } = useTranslation();
  const percent = (stepLoading + 0.5) * 25;

  // biome-ignore lint/correctness/useExhaustiveDependencies: dependencies are intentional
  useEffect(() => {
    if (stepLoading >= STEP_LOADING.length && percent >= 100) {
      logEvent({
        event: AMPLITUDE_TRACKS.LEAD_SENT_VARIANT,
        data: {
          ...getSourceEventParams(),
          Product: 'B2B Landing',
          Step: FormSteps.FORM_STEP_LOAD,
        },
      });

      setTimeout(() => {
        setisVisibleModal(true);
      }, 1500);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stepLoading, percent]);

  if (isVisibleModal) {
    return <StepCompleted />;
  }

  return (
    <div
      className="m-auto"
      css={css`
        max-width: 634px;
      `}
    >
      <div className="text-center">
        <div
          className="rounded-full relative overflow-hidden mx-auto"
          css={css`
            width: 59px;
            height: 59px;
            border: 4px solid ${({ theme }) => theme.colors.primary.main};

            ${({ theme }) => theme.breakpoints.up('md')} {
              width: 96px;
              height: 96px;
            }
          `}
        >
          <Image
            src="https://crehana-public-catalog.imgix.net/images/app/gallery/2022/04/07/8f198ff5/fd933f30.png"
            alt="consultant"
            layout="fill"
            objectFit="cover"
            objectPosition="center"
            quality={100}
          />
        </div>
        <div className="mt-8">
          <span className="font-h3-reg-md text-white">
            {t('LOADER_FINAL_STEP_TITLE', {
              interpolation: { name: nameUser },
            })}
          </span>
        </div>
      </div>
      <ProgressBar
        className="mt-20 sm:mt-40"
        full
        progress={percent}
        backgroundClassName="rounded-10 p-4 h-20 bg-neutral-dark-700"
        barClassName="rounded-10 h-12 bg-primary-lighter"
        transitionTime={2500}
      />
      <div className="w-full mt-52">
        {STEP_LOADING.map((item, i) => (
          <div
            key={item.id}
            className="flex justify-between items-center py-16 border-b border-solid"
            style={{ borderColor: '#292C47' }}
          >
            <span className="font-poppins font-normal text-16 block w-1/2 text-white">
              {t(item.i18nKey)}
            </span>
            <Count
              init={i === stepLoading}
              setNextStep={() => setStepLoading(prev => prev + 1)}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default LoaderFinalStep;
